// extracted by css-extract-rspack-plugin
export default {"overflowEllips":"ApplicationRow__overflowEllips--VvvMp"};